<template>
  <article class="panel is-primary">
    <p class="panel-heading">
      Órdenes
    </p>
    <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
      <thead>
      <tr>
        <th v-if="canDrop"></th>
        <th>Orden</th>
        <th>Fecha</th>
        <th>Paciente</th>
        <th>Serie</th>
        <th>Nota</th>
        <th>Factura</th>
        <th>Importe</th>
        <th>I.V.A.</th>
        <th>Fecha P.G.</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, key) in orders" :key="key">
        <td v-if="canDrop">
          <b-button @click="$emit('drop-item', key)">
            <b-icon
              icon="window-close"
              size="is-small">
            </b-icon>
          </b-button>
        </td>
        <td>{{ item.no }}</td>
        <td>{{ item.date | date }}</td>
        <td>{{ item.patient.full_name }}</td>
        <td>{{ invoice ? invoice.serie : '' }}</td>
        <td>{{ item.note }}</td>
        <td>{{ invoice ? invoice.folio : '' }}</td>
        <td>{{ item.total | currency }}</td>
        <td>{{ invoice ? invoice.tax_rate : '' }}</td>
        <td>{{ invoice ? invoice.datetime : '' }}</td>
      </tr>
      <template v-for="item in index">
        <tr class="tr__empty">
          <td v-if="canDrop"></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </template>
      <tr>
        <td v-if="canDrop"></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>{{ total | currency }}</td>
        <td></td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </article>
</template>

<script>
export default {
  name: "InvoiceTable",
  props: {
    invoice: Object,
    orders: Array,
    canDrop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      limit: 4,
    }
  },
  computed: {
    index() {
      const items = [];
      for (let i = this.orders.length; i < this.limit; i++) {
        items.push(i);
      }
      return items;
    },
    total() {
      let total = 0;
      this.orders.map((item) => {
        total += item.total;
      });
      return total;
    },
  }
}
</script>

<style scoped>
.tr__empty {
  height: 28px;
}

</style>
